(() => {
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const shopRoot = window.Shopify?.routes?.root || '/';

  const lockBody = () => document.body.classList.add('is-locked');
  const unlockBody = () => {
    if (!qs('.fz-modal.is-open') && !qs('.fz-mobile-menu.is-open')) {
      document.body.classList.remove('is-locked');
    }
  };

  const openModal = (modal) => {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockBody();
    qs('input', modal)?.focus();
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    unlockBody();
  };

  const mobileMenu = qs('#FzMobileMenu');
  const openMenu = () => {
    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    lockBody();
  };
  const closeMenu = () => {
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    unlockBody();
  };

  qsa('[data-mobile-menu-open]').forEach((button) => button.addEventListener('click', openMenu));
  qsa('[data-mobile-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));

  qsa('[data-product-root]').forEach((root) => {
    const json = qs('[data-product-json]', root);
    if (!json) return;

    let variants = [];
    try {
      variants = JSON.parse(json.textContent || '[]');
    } catch {
      return;
    }

    const optionGroups = qsa('[data-option-group]', root);
    const selected = optionGroups.map(
      (group) => qs('.is-selected', group)?.dataset.value || ''
    );
    const variantInput = qs('[data-variant-id]', root);
    const price = qs('[data-product-price]', root);
    const buyButtons = qsa('[data-buy-now]', root);
    const modal = qs('[data-quick-order-modal]', root);
    const summaryVariant = qs('[data-summary-variant]', root);
    const summaryPrice = qs('[data-summary-price]', root);
    let currentVariant = null;

    const formatPrice = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
      return new Intl.NumberFormat(document.documentElement.lang || 'ar-MA', {
        style: 'currency',
        currency: 'MAD'
      }).format(Number(cents || 0) / 100);
    };

    const updateVariant = () => {
      if (optionGroups.length === 0) {
        const initialVariantId = variantInput?.value;
        currentVariant =
          variants.find((variant) => String(variant.id) === String(initialVariantId)) ||
          variants[0] ||
          null;
      } else {
        currentVariant = variants.find((variant) =>
          variant.options.every((option, index) => option === selected[index])
        );
      }

      if (!currentVariant) {
        buyButtons.forEach((button) => {
          button.disabled = true;
        });
        return;
      }

      if (variantInput) variantInput.value = currentVariant.id;
      if (price) price.textContent = formatPrice(currentVariant.price);
      if (summaryVariant) {
        const visibleTitle = currentVariant.title && currentVariant.title !== 'Default Title';
        summaryVariant.textContent = visibleTitle ? currentVariant.title : '';
        summaryVariant.hidden = !visibleTitle;
      }
      if (summaryPrice) summaryPrice.textContent = price?.textContent || formatPrice(currentVariant.price);

      buyButtons.forEach((button) => {
        button.disabled = !currentVariant.available;
        button.textContent = currentVariant.available
          ? button.dataset.availableText
          : button.dataset.soldText;
      });
    };

    qsa('[data-option-button]', root).forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.optionIndex);
        selected[index] = button.dataset.value || '';
        qsa(`[data-option-index="${index}"]`, root).forEach((item) =>
          item.classList.remove('is-selected')
        );
        button.classList.add('is-selected');
        updateVariant();
      });
    });

    qsa('[data-qty-minus]', root).forEach((button) => {
      button.addEventListener('click', () => {
        const input = qs('[data-quantity]', root);
        if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
      });
    });

    qsa('[data-qty-plus]', root).forEach((button) => {
      button.addEventListener('click', () => {
        const input = qs('[data-quantity]', root);
        if (input) input.value = Math.min(20, Number(input.value || 1) + 1);
      });
    });

    buyButtons.forEach((button) => {
      button.addEventListener('click', () => {
        updateVariant();
        if (currentVariant?.available) openModal(modal);
      });
    });

    qsa('[data-modal-close]', root).forEach((button) =>
      button.addEventListener('click', () => closeModal(modal))
    );
    modal?.addEventListener('click', (event) => {
      if (event.target.matches('[data-modal-backdrop]')) closeModal(modal);
    });

    const form = qs('[data-quick-order-form]', root);
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      const message = qs('[data-form-message]', form);
      const submit = qs('button[type="submit"]', form);
      const fullName = qs('[name="fullName"]', form)?.value.trim();
      const phone = qs('[name="phone"]', form)?.value.trim();
      const address = qs('[name="address"]', form)?.value.trim();
      const quantity = Math.max(1, Math.min(20, Number(qs('[data-quantity]', root)?.value || 1)));
      const variantId = Number(variantInput?.value);

      const showMessage = (text, type = 'error') => {
        if (!message) return;
        message.textContent = text;
        message.className = `fz-form-message is-visible ${type === 'error' ? 'is-error' : 'is-success'}`;
      };

      if (!fullName || !phone || !address) {
        showMessage(form.dataset.requiredText || 'المرجو إدخال الاسم ورقم الهاتف والعنوان.');
        return;
      }

      if (!variantId || !currentVariant?.available) {
        showMessage(form.dataset.errorText || 'هذا المنتج غير متوفر حالياً.');
        return;
      }

      submit.disabled = true;
      submit.textContent = 'جاري فتح صفحة إتمام الطلب...';
      if (message) message.className = 'fz-form-message';

      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
                properties: {
                  '_Quick order name': fullName,
                  '_Quick order phone': phone,
                  '_Quick order address': address
                }
              }
            ]
          })
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || form.dataset.errorText);
        }

        const checkoutUrl = new URL(`${shopRoot}checkout`, window.location.origin);
        checkoutUrl.searchParams.set('checkout[shipping_address][first_name]', fullName);
        checkoutUrl.searchParams.set('checkout[shipping_address][address1]', address);
        checkoutUrl.searchParams.set('checkout[shipping_address][phone]', phone);
        checkoutUrl.searchParams.set('checkout[shipping_address][country]', 'Morocco');
        window.location.assign(checkoutUrl.toString());
      } catch (error) {
        showMessage(error.message || form.dataset.errorText || 'تعذر فتح صفحة إتمام الطلب. حاولي مرة أخرى.');
        submit.disabled = false;
        submit.textContent = form.dataset.submitText || 'تأكيد الطلب';
      }
    });

    updateVariant();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    qsa('.fz-modal.is-open').forEach(closeModal);
    closeMenu();
  });
})();
